<script setup lang="ts">
import SeminarDescription from './SeminarDescription.vue';
import SeminarDetailEntryButton from './SeminarDetailEntryButton.vue';
import SeminarTarget from './SeminarTarget/SeminarTarget.vue';
import { getCoverImageUrl } from '~/components/organisms/SeminarCard/helpers';
import { type FragmentType, graphql } from '~/gql';

const props = defineProps<{
  seminar: FragmentType<typeof SeminarFragment>;
  isEntryButtonDisabled: boolean;
}>();

const SeminarFragment = graphql(`
  fragment SeminarDetailDescriptionSectionSeminar on Seminar {
    id
    coverImage
    description
    applicantsDescription
    timerexUrl: timerexURL
  }
`);

const seminar = useComputedFragment(SeminarFragment, () => props.seminar);

const { buildImgixURL } = useImgixURL();

const coverImageUrl = computed(() =>
  seminar.value.coverImage
    ? buildImgixURL(seminar.value.coverImage, { width: 1080, quality: 100 })
    : getCoverImageUrl(seminar.value.id)
);
</script>

<template>
  <div :class="$style.container">
    <img
      v-if="coverImageUrl"
      :class="$style.container__cover"
      :src="coverImageUrl"
    />
    <SeminarDetailEntryButton
      :class="$style.container__button"
      :timerex-url="seminar.timerexUrl ?? undefined"
      :seminar-id="seminar.id"
      :disabled="isEntryButtonDisabled"
      variant="whiteBgOnMobile"
    />
    <SeminarTarget :body="seminar.applicantsDescription" />
    <SeminarDescription :description="seminar.description" />
    <SeminarDetailEntryButton
      :class="$style.container__button"
      :timerex-url="seminar.timerexUrl ?? undefined"
      :seminar-id="seminar.id"
      :disabled="isEntryButtonDisabled"
      variant="whiteBgOnMobile"
    />
  </div>
</template>

<style module lang="scss">
.container {
  & > *:nth-child(n + 2) {
    margin-top: 24px;
  }

  &__cover {
    width: 100%;
    border-radius: 8px;
    aspect-ratio: 2 / 1;
    object-fit: cover;
    @include mobile-only {
      width: 100vw;
      max-width: 100vw;
      margin: 0 calc((100vw - 100%) / -2);
      border-radius: unset;
    }
  }
}
</style>
